const buttonVariants = {
  root: {
    px: [2, 3, 3],
    py: '6px',
    // hack to keep border inside
    // height: 'scale.7',
    height: 'auto',
    variant: 'text.body2',
    lineHeight: '1',
    borderRadius: 'circle',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'white',
    color: 'white',
    flex: '0 0 auto',
    alignSelf: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    alignContent: 'center',
    '&[disabled]': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
    '& > svg': {
      verticalAlign: 'middle',
      size: '1.05em',
      margin: '-0.05em',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  primary: {
    variant: 'buttons.root',
    bg: 'primary',
    borderColor: 'primary',
    '&:hover': {
      bg: 'primaryHover',
      borderColor: 'primaryHover',
      cursor: 'pointer',
    },
  },
  success: {
    variant: 'buttons.root',
    bg: 'statusSuccess',
    borderColor: 'statusSuccess',
    '&:hover': {
      bg: 'statusSuccess',
      borderColor: 'statusSuccess',
      cursor: 'pointer',
    },
  },
  secondary: {
    variant: 'buttons.root',
    bg: 'secondary',
    borderColor: 'secondary',
    '&:hover': {
      bg: 'secondaryHover',
      borderColor: 'secondaryHover',
      cursor: 'pointer',
    },
  },
  danger: {
    variant: 'buttons.root',
    bg: 'danger',
    borderColor: 'danger',
    '&:hover': {
      bg: 'dangerHover',
      borderColor: 'dangerHover',
      cursor: 'pointer',
    },
  },
  outline: {
    variant: 'buttons.root',
    bg: 'field',
    color: 'onField',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'fieldBorder',
    '&:hover': {
      bg: 'fieldBorder',
      borderColor: 'fieldBorder',
      cursor: 'pointer',
    },
  },
  link: {
    appearance: 'auto',
    p: 0,
    border: 'none',
    borderRadius: 0,
    height: 'auto',
    bg: 'transparent',
    color: 'primary',
    fontSize: 1,
    fontFamily: 'inherit',
    lineHeight: 'normal',
    textAlign: 'left',
    alignSelf: 'flex-start',
    cursor: 'pointer',
    '&:disabled': { color: 'fieldBorderHover', cursor: 'default' },
  },
  utilityIcon: {
    bg: 'utilBtn',
    borderColor: 'utilBtn',
    color: 'text',
    borderRadius: 'circle',
    variant: 'buttons.utility',
    size: 24,
    p: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 24px',
    lineHeight: '1',
    '&[disabled]': {
      opacity: 0.25,
      pointerEvents: 'none',
    },
    '&:hover': {
      bg: 'utilBtnHover',
      borderColor: 'utilBtnHover',
      cursor: 'pointer',
    },
  },
  utilityIconDark: {
    variant: 'buttons.utilityIcon',
    color: 'white',
    bg: 'secondary',
    borderColor: 'secondary',
    '&:hover': {
      bg: 'secondaryHover',
      borderColor: 'secondaryHover',
      cursor: 'pointer',
    },
  },
  utilityIconDanger: {
    variant: 'buttons.utilityIcon',
    color: 'white',
    bg: 'danger',
    borderColor: 'danger',
    '&:hover': {
      bg: 'dangerHover',
      borderColor: 'dangerHover',
      cursor: 'pointer',
    },
  },
};

export default buttonVariants;
